export interface ModuleField {
  field: string
  fieldName: string
}

export interface IntegrationModule {
  id: string
  name: string
  endpoint: string
  createEndpoint?: string
  fields: ModuleField[]
}

export const integrationModules: IntegrationModule[] = [
  {
    id: 'companies',
    name: 'Empresas',
    endpoint: '/companies/companies',
    createEndpoint: '/companies/companies',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'companyName', fieldName: 'Razão Social' },
      { field: 'cnpj', fieldName: 'CNPJ' },
      { field: 'cpf', fieldName: 'CPF' },
      { field: 'stateRegistration', fieldName: 'Inscrição Estadual' },
      { field: 'contactName', fieldName: 'Nome do Contato' },
      { field: 'phone', fieldName: 'Telefone' },
      { field: 'email', fieldName: 'E-mail' },
      { field: 'companyTypes', fieldName: 'Tipo de Empresa' },
      { field: 'cep', fieldName: 'CEP' },
      { field: 'street', fieldName: 'Rua' },
      { field: 'number', fieldName: 'Número' },
      { field: 'neighborhood', fieldName: 'Bairro' },
      { field: 'city', fieldName: 'Cidade' },
      { field: 'state', fieldName: 'Estado' },
    ]
  },
  {
    id: 'equipment',
    name: 'Equipamentos',
    endpoint: '/equipment/equipment',
    createEndpoint: '/equipment/equipment',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'code', fieldName: 'Código' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'model', fieldName: 'Modelo' },
      { field: 'manufacturer', fieldName: 'Fabricante' },
      { field: 'year', fieldName: 'Ano' },
      { field: 'dimension', fieldName: 'Dimensão' },
      { field: 'weight', fieldName: 'Peso' },
      { field: 'costPerHour', fieldName: 'Custo por Hora' },
      { field: 'capacity', fieldName: 'Capacidade' },
      { field: 'machineType', fieldName: 'Tipo de Máquina' },
      { field: 'machineLocation', fieldName: 'Localização' },
    ]
  },
  {
    id: 'vehicles',
    name: 'Veículos',
    endpoint: '/equipment/vehicles',
    createEndpoint: '/equipment/vehicles',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'plate', fieldName: 'Placa' },
      { field: 'brand', fieldName: 'Marca' },
      { field: 'model', fieldName: 'Modelo' },
      { field: 'year', fieldName: 'Ano' },
      { field: 'color', fieldName: 'Cor' },
      { field: 'capacity', fieldName: 'Capacidade' },
    ]
  },
  {
    id: 'resources',
    name: 'Insumos',
    endpoint: '/resource/resource',
    createEndpoint: '/resource/resource',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'code', fieldName: 'Código' },
      { field: 'category', fieldName: 'Categoria' },
      { field: 'type', fieldName: 'Tipo' },
      { field: 'description', fieldName: 'Descrição' },
      { field: 'price', fieldName: 'Preço' },
      { field: 'supplier', fieldName: 'Fornecedor' },
    ]
  },
  {
    id: 'services',
    name: 'Serviços',
    endpoint: '/services/service-stage/stages',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'category', fieldName: 'Categoria' },
      { field: 'type', fieldName: 'Tipo' },
    ]
  },
  {
    id: 'production',
    name: 'Produção',
    endpoint: '/production-flow/production',
    fields: [
      { field: 'id', fieldName: 'ID' },
      { field: 'name', fieldName: 'Nome' },
      { field: 'status', fieldName: 'Status' },
      { field: 'startDate', fieldName: 'Data Início' },
      { field: 'endDate', fieldName: 'Data Fim' },
    ]
  },
]

export const integrationTypes = [
  { id: 'read', name: 'Leitura', description: 'Apenas consulta os dados existentes' },
  { id: 'write', name: 'Registro', description: 'Consulta e permite criar novos registros' },
]

export const getModuleById = (id: string): IntegrationModule | undefined => {
  return integrationModules.find(module => module.id === id)
}

export const getFieldsByModuleId = (moduleId: string): ModuleField[] => {
  const module = getModuleById(moduleId)
  return module?.fields || []
}
